import React from 'react';
import {
  PlaceholderCardList,
  PlaceholderSection,
  PlaceholderSectionHeader,
  PlaceholderSectionHeaderMore,
  PlaceholderSectionHeaderTitle
} from './styled';
import { SectionPlaceholderProps } from './types';

export const SectionPlaceholder = ({
  children,
  noHeader = false,
  column = false,
  white = true,
  more = true,
  isCardsLayout = false,
  rowCount = 1,
  deskRowCount = 4,
  height
}: SectionPlaceholderProps) => {
  const sectionHeader = (
    <PlaceholderSectionHeader $isCardsLayout={isCardsLayout}>
      <PlaceholderSectionHeaderTitle />
      {more && <PlaceholderSectionHeaderMore />}
    </PlaceholderSectionHeader>
  );

  return (
    <PlaceholderSection
      white={white}
      $isCardsLayout={isCardsLayout}
      $height={height}
    >
      {!noHeader && sectionHeader}
      {Array.from({ length: rowCount }, (_, index) => (
        <PlaceholderCardList
          column={column}
          key={index}
          $deskRowCount={deskRowCount}
        >
          {children}
        </PlaceholderCardList>
      ))}
    </PlaceholderSection>
  );
};
